import Image from "next/image";
import { Globe } from "lucide-react";
import { normalizeSocialService } from "@/shared/utils/headerSocialLinks";
import tgIcon from "public/icons/tg.svg";
import tgDarkIcon from "public/icons/tg-dark.svg";
import vkIcon from "public/icons/vk.svg";
import vkDarkIcon from "public/icons/vk-dark.svg";
import maxIcon from "public/icons/max.svg";
import maxDarkIcon from "public/icons/max-dark.svg";

const HEADER_ICONS: Record<string, string> = {
  telegram: tgIcon,
  vk: vkIcon,
  max: maxIcon,
};

const MENU_ICONS: Record<string, string> = {
  telegram: tgDarkIcon,
  vk: vkDarkIcon,
  max: maxDarkIcon,
};

type SocialIconVariant = "header" | "menu";

interface SocialIconProps {
  service: string;
  variant: SocialIconVariant;
  className?: string;
}

export function SocialIcon({ service, variant, className }: SocialIconProps) {
  const normalizedService = normalizeSocialService(service);
  const icons = variant === "header" ? HEADER_ICONS : MENU_ICONS;
  const src = icons[normalizedService];

  if (!src) {
    return (
      <Globe
        className={className ?? (variant === "header" ? "size-6 text-header-top-fg" : "size-8 text-foreground")}
        aria-hidden
      />
    );
  }

  const size = variant === "header" ? 24 : 32;

  return (
    <Image
      src={src}
      alt=""
      width={size}
      height={size}
      className={className ?? (variant === "header" ? "size-6" : "size-8 md:size-8")}
    />
  );
}
